import { __rest } from "tslib";
import * as React from 'react';
import { st, classes } from './CopyUrlButton.st.css';
import { Check, Link } from '@wix/wix-ui-icons-common/on-stage';
import { TPAComponentsConsumer } from '../../../../esm/components/TPAComponentsConfig';
import { Toast, ToastSkin, ToastPlacement } from '../Toast';
import { SocialBarIcon } from '../SocialBar/SocialBarIcon';
const delay = (time) => new Promise((resolve) => setTimeout(resolve, time));
class CopyUrlButton extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { success: false };
        this.inputRef = React.createRef();
        this._renderSuccess = ({ mobile }) => {
            const { successText } = this.props;
            if (mobile) {
                return (React.createElement(Toast, { skin: ToastSkin.success, placement: ToastPlacement.bottomFullWidth, shouldAnimate: true, isShown: true },
                    React.createElement("div", { className: classes.success },
                        React.createElement(Check, null),
                        React.createElement("span", { className: classes.successText }, successText))));
            }
            return (React.createElement("div", { className: classes.success },
                React.createElement(Check, { className: classes.checkIcon }),
                React.createElement("span", { className: classes.successText }, successText)));
        };
        this._onButtonClick = async (event) => {
            if (document.queryCommandSupported('copy')) {
                this.inputRef.current.select();
                document.execCommand('copy');
            }
            if (this.props.onClick) {
                this.props.onClick(event);
            }
            this.setState({ success: true });
            await delay(2000);
            this.setState({ success: false });
        };
        this._renderIconButton = ({ mobile }) => {
            const { success } = this.state;
            const _a = this.props, { tooltipText, socialBarTheme, url, successText } = _a, otherProps = __rest(_a, ["tooltipText", "socialBarTheme", "url", "successText"]);
            if (success && !mobile) {
                return null;
            }
            return (React.createElement(SocialBarIcon, Object.assign({ tooltip: tooltipText, socialBarTheme: socialBarTheme, icon: React.createElement(Link, null), as: "button" }, otherProps, { onClick: this._onButtonClick })));
        };
    }
    render() {
        const { success } = this.state;
        const { url, socialBarTheme, className } = this.props;
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile }) => (React.createElement("div", { className: st(classes.root, { theme: socialBarTheme, mobile }, className), "data-hook": this.props['data-hook'] },
            React.createElement("input", { className: classes.copyInput, ref: this.inputRef, value: url, readOnly: true, "aria-hidden": "true", tabIndex: -1 }),
            this._renderIconButton({ mobile }),
            success && this._renderSuccess({ mobile })))));
    }
}
CopyUrlButton.defaultProps = { socialBarTheme: 'light' };
export { CopyUrlButton };
//# sourceMappingURL=CopyUrlButton.js.map